import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';

export enum CardTypes {
  Promo = 'promo',
  Action = 'action',
  Info = 'info',
  ActiveProduct = 'active-product',
  Basic = 'basic'
}
@Component({
    selector: 'bw-card-legacy',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponentLegacy implements OnInit {
  @Input() cardType: CardTypes;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() bgImageSrc: string;
  @Input() closeable: boolean;
  @Input() invertedColor: boolean;
  @Input() cardTextColor: string;
  @Input() cardBannerColor: string;

  @Output() closeCard = new EventEmitter();
  @Output() cardAction = new EventEmitter();

  isPromoCard: boolean;
  isActionCard: boolean;
  isInfoCard: boolean;
  isActiveProductCard: boolean;
  isBasicCard: boolean;

  @HostBinding('className') hostClass: string;
  @HostBinding('class.has-banner') hasCardBanner = false;
  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {
    if (this.cardType === CardTypes.Promo) {
      this.isPromoCard = true;
    }
    if (this.cardType === CardTypes.Action) {
      this.isActionCard = true;
    }
    if (this.cardType === CardTypes.Info) {
      this.isInfoCard = true;
      this.hostClass = 'info-card';
    }
    if (this.cardType === CardTypes.ActiveProduct) {
      this.isActiveProductCard = true;
      this.hostClass = 'activated-product';
    }
    if (this.cardType === CardTypes.Basic) {
      this.isBasicCard = true;
      this.hostClass = 'basic-card';
    }
    if (this.invertedColor) {
      this.hostClass = 'inverted';
    }
    this.hasCardBanner = this.elRef.nativeElement.lastElementChild.localName === "bw-card-banner-legacy";
  }

  handleCloseCard(event: Event) {
    this.closeCard.emit();
  }

  handleCardAction(event: Event) {
    this.cardAction.emit(event);
  }
}

@Component({
    selector: 'bw-card-header-legacy',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class CardHeaderComponentLegacy {}

@Component({
    selector: 'bw-card-body-legacy',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class CardBodyComponentLegacy {}

@Component({
    selector: 'bw-card-footer-legacy',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class CardFooterComponentLegacy {}

@Component({
    selector: 'bw-card-banner-legacy',
    template: ` <div class="card-banner"><div class="card-banner-bg" [ngStyle]="{ 'background-color': cardBannerColor }"></div><ng-content></ng-content></div> `,
    styleUrls: ['card-banner.scss'],
    standalone: false
})
export class CardBannerComponentLegacy {
  @Input() cardBannerColor: string;
}
